import { configureStore } from "@reduxjs/toolkit";

import applicationReducer from "@features/application/slice";
import authReducer from "@features/auth/slice";
import jobManagementReducer from "@features/jobManagement/slice";
import managementRoundTableReducer from "@features/managementRoundTable/slice";
import managementUsersReducer from "@features/managementUser/slice";
import messagesReducer from "@features/messages/slice";
import paymentReducer from "@features/payment/slice";
import sidebarReducer from "@features/sidebar/slice";
import usersReducer from "@features/user/slice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    managementRoundTable: managementRoundTableReducer,
    users: usersReducer,
    managementUsers: managementUsersReducer,
    sideBar: sidebarReducer,
    application: applicationReducer,
    jobManagement: jobManagementReducer,
    payment: paymentReducer,
    messages: messagesReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
